import angular from 'angular';
import angularUiBootstrap from 'angular-ui-bootstrap';
import {PrintDesignService} from "./print-design.service";

export default angular.module('slViz.printDesignModule', [
    angularUiBootstrap
])
    .service('PrintDesignService', PrintDesignService)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/print-design/index.js